import { useEffect, useState } from "react";
import axios from "axios";
import PolicyLayout from "../components/PolicyLayout";
import { sanitizeHtml } from "../lib/sanitize";
import { apiOrigin } from "../lib/apiBase";

const API = `${apiOrigin}/api`;

function formatDanishDate(iso) {
    if (!iso) return null;
    try {
        const d = new Date(iso);
        return d.toLocaleDateString("da-DK", {
            day: "numeric",
            month: "long",
            year: "numeric",
        });
    } catch {
        return null;
    }
}

export default function DpaPage() {
    const [doc, setDoc] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        document.title = "Databehandleraftale · Cleany.dk";
        axios
            .get(`${API}/legal/dpa`)
            .then((r) => setDoc(r.data))
            .catch((e) => setError(e?.response?.data?.detail || "Kunne ikke indlæse"));
    }, []);

    const lastUpdated = formatDanishDate(doc?.updated_at);
    const title = doc?.title || "Databehandleraftale";

    return (
        <PolicyLayout
            title={title}
            lastUpdated={lastUpdated ? `${lastUpdated} (version ${doc?.version})` : null}
        >
            {error && (
                <p className="text-rose-700 bg-rose-50 border border-rose-200 rounded-lg px-4 py-3 text-sm">
                    {error}
                </p>
            )}
            {!doc && !error && (
                <p className="text-slate-400 text-sm">Indlæser…</p>
            )}
            {doc?.html && (
                <div
                    data-testid="dpa-body"
                    dangerouslySetInnerHTML={{ __html: sanitizeHtml(doc.html) }}
                />
            )}
        </PolicyLayout>
    );
}
